import http from '@/http'

const PATH = '/cancellations/summary'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listSummary (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{periodId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listReasons ({periodId, params}) {
        try {
            const response = await http.get(
                `${PATH}/${periodId}/reasons`,
                {params}
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
